import {
  createFrontendPlugin,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';
import { Navigate } from 'react-router-dom';

const LearnRedirect = () => (
  <Navigate to="/docs/default/component/portal-docs" replace />
);

const learnRedirect = PageBlueprint.make({
  params: {
    path: '/learn',
    loader: async () => <LearnRedirect />,
  },
});

export const learnRedirectPlugin = createFrontendPlugin({
  pluginId: 'learn-redirect',
  extensions: [learnRedirect],
});
